import { EventObject } from '@xstate/store-react';
import { getSessionId } from '../../../services/api/getSessionId';
import { store } from '../../store';
import { log } from '@domgen/shared/utils/log';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';

/**
 * @description Session Create
 * This event is responsible for creating a new session when the user starts the app. It does this by:
 * 1. Logging the session creation attempt
 * 2. Making an API call to retrieve a new session ID
 * 3. If successful, it sends a SET_SESSION event with the new session ID to update the store
 * 4. If it fails to retrieve a session ID, it logs an error and sends a SESSION_CREATION_FAILED event
 * @param {StoreContext} _context - The current store context (not used in this event)
 * @param {EventObject | undefined} _event - The event object (not used in this event)
 * @param {{ effect: (effect: () => Promise<void>) => void }} enqueue - An object with an effect function to enqueue side effects
 * @returns {void}
 */
export const createSession = <T extends EventObject | undefined = EventObject>(
  _context: StoreContext,
  _event: T,
  enqueue: { effect: (effect: () => Promise<void>) => void },
): void => {
  log.debug({ message: StoreEvent.CREATE_SESSION });
  enqueue.effect(async () => {
    try {
      const id = await getSessionId();
      log.debug({ message: 'Session created', data: { sessionId: id } });
      store.send({ type: StoreEvent.SET_SESSION, data: { id } });
    } catch {
      log.error({
        message: 'Session creation failed',
        data: { error: 'Failed to retrieve session ID' },
      });
      store.send({ type: StoreEvent.SESSION_CREATION_FAILED });
    }
  });

  //   return {
  //     ...context,
  //     app: { ...context.app, status: AppStatus.LOADING, session: { id: 'session-123' } },
  //   };
};
